<template>
  <div class="myaccount-address">
                        <p>The following addresses will be used on the checkout page by default.</p>
                        <div class="row">
                          <div class="col">
                            <h4 class="small-title">BILLING ADDRESS</h4>
                            <address>
                              {{ addresses.billing }}
                            </address>
                          </div>
                          <div class="col">
                            <h4 class="small-title">SHIPPING ADDRESS</h4>
                            <address>
                              {{ addresses.shipping }}
                            </address>
                          </div>
                        </div>
                      </div>
</template>

<script>
export default {
  name: "ShowAddresses",
  props: ['addresses']
}
</script>

<style>

</style>
